import { FC } from 'react';

export const ParentalControl: FC = () => {
  return (
    <section className="w-full bg-[#1E1E2D] py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Contenido */}
            <div className="text-white space-y-6">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent">
                Control Parental
              </h2>
              <p className="text-lg md:text-xl text-gray-300 leading-relaxed">
                Mantente informado sobre el progreso de tus hijos en su educación financiera. 
                Nuestro panel de control te permite supervisar su aprendizaje y acompañarlos 
                en su camino hacia la independencia financiera.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center mt-1">
                    <div className="w-3 h-3 rounded-full bg-primary"></div>
                  </div>
                  <div className="space-y-1">
                    <span className="text-white font-semibold block">Seguimiento del Progreso</span>
                    <span className="text-gray-300 text-sm">
                      Visualiza el avance de tus hijos en los diferentes módulos y 
                      mantente al tanto de su desarrollo en educación financiera.
                    </span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-secondary/20 flex items-center justify-center mt-1">
                    <div className="w-3 h-3 rounded-full bg-secondary"></div>
                  </div>
                  <div className="space-y-1">
                    <span className="text-white font-semibold block">Resumen de Actividades</span>
                    <span className="text-gray-300 text-sm">
                      Conoce qué temas están aprendiendo tus hijos y qué actividades 
                      han completado en su viaje de aprendizaje financiero.
                    </span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-accent/20 flex items-center justify-center mt-1">
                    <div className="w-3 h-3 rounded-full bg-accent"></div>
                  </div>
                  <div className="space-y-1">
                    <span className="text-white font-semibold block">Supervisión Segura</span>
                    <span className="text-gray-300 text-sm">
                      Accede a un espacio seguro donde puedes supervisar el contenido 
                      al que acceden tus hijos y su interacción con la plataforma.
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            {/* Imagen */}
            <div className="relative">
              <div className="relative mx-auto max-w-[600px]">
                {/* Marco de dispositivo */}
                <div className="absolute inset-0 bg-gradient-to-r from-primary/20 via-secondary/20 to-accent/20 rounded-[2rem] transform scale-[1.02] blur-lg"></div>
                <div className="relative bg-[#2A2A3A] rounded-[2rem] p-4 shadow-2xl">
                  {/* Barra superior del dispositivo */}
                  <div className="flex items-center gap-2 mb-4">
                    <div className="flex gap-2">
                      <div className="w-3 h-3 rounded-full bg-red-500"></div>
                      <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                      <div className="w-3 h-3 rounded-full bg-green-500"></div>
                    </div>
                  </div>
                  {/* Imagen de la pantalla */}
                  <img
                    src="https://media.financieramente.kids/panel-control.png"
                    alt="Panel de Control Parental"
                    className="w-full h-auto rounded-lg"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
